import { loadStripe } from '@stripe/stripe-js';

let stripePromise: Promise<any>;

export const getStripe = () => {
  if (!stripePromise && import.meta.env.VITE_STRIPE_PK) {
    stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PK);
  }
  return stripePromise;
};
